// extracted by mini-css-extract-plugin
export default {"primaryColor":"#ff7606","primaryColorWithAlpha":"#ececec","mainBgColor":"#ececec","secondBgColor":"#fff","menuTextColor":"#29292c"};